import { AfterViewInit, Component, Input, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { AddressComponent } from "../address";
import { ApsService } from "src/app/services";
import { CrossFieldErrorMatcher } from "src/app/shared/helpers";
import { ChangeDetectorRef } from "@angular/core";
import { CreditCardInfo } from "src/app/models";

@Component({
  selector: "app-new-card",
  templateUrl: "./new-card.component.html",
  styleUrls: ["./new-card.component.scss"]
})
export class NewCardComponent implements OnInit, AfterViewInit
{

  public form: FormGroup;
  @Input() public showPrimary: boolean = true;
  @Input() public showAddress: boolean = true;
  @Input() public showSave: boolean = false;
  // public saveCard: boolean = false;

  public years: number[] = Array.from({ length: 10 }, (_, i) => (new Date()).getFullYear() + i);
  public cardType = "genericcard";
  public errorMatcher = new CrossFieldErrorMatcher(["invalidMonth"]);

  @ViewChild(AddressComponent) public addressElement: AddressComponent;
  constructor(
    private fb: FormBuilder,
    private apsService: ApsService,
    private changeDetectorRef: ChangeDetectorRef,
  ) { }

  public ngOnInit(): void
  {
    this.form = this.fb.group({
      FirstName: ["", [Validators.required]],
      LastName: ["", [Validators.required]],
      Number: ["", [Validators.required, this.luhnValidate.bind(this), this.cardTypeValidate.bind(this), this.cardCheck.bind(this)]],
      ExpirationMonth: ["", [Validators.required]],
      ExpirationYear: ["", [Validators.required]],
      Primary: [false]
    }, { validator: this.dateValidate.bind(this) });
  }

  public ngAfterViewInit(): void
  {
    this.changeDetectorRef.detectChanges();
    if (this.showAddress)
    {
      this.form.addControl("Address", this.addressElement.form);
      this.addressElement.form.setParent(this.form);
    }
  }

  private luhnValidate(control: FormControl): ValidationErrors | null
  {
    const result = this.apsService.luhnValidate(control.value.replace(/\s/g, ""));
    if (!result)
    {
      return { invalidCardNumber: true };
    }
    return null;
  }

  private cardTypeValidate(control: FormControl): ValidationErrors | null
  {
    const type = this.apsService.detectCardType(control.value.replace(/\s/g, ""));
    const result = this.apsService.isCardTypeAccepted(type);

    if (!result)
    {
      return { invalidCardType: true };
    }

    return null;
  }
  // public handleClickEvent(checked: boolean): boolean {

  //   this.saveCard = checked;
  //   return this.saveCard;
  // }

  private dateValidate(fg: FormGroup): ValidationErrors | null
  {

    const expYear = parseInt(fg.get("ExpirationYear").value);
    const expMonth = parseInt(fg.get("ExpirationMonth").value, 10);
    const currentDate = new Date();

    if (expYear > 999)
    {
      if (expMonth < 1 || expMonth > 12)
      {
        return { invalidMonth: true }
      }
      if (expYear < currentDate.getFullYear())
      {
        return { invalidMonth: true }
      }
      if (expYear <= currentDate.getFullYear() && expMonth < (currentDate.getMonth() + 1))
      {
        return { invalidMonth: true };
      }
    }

    return null;
  }

  public handleCCInput(cardNumber: string): void
  {
    this.cardType = this.apsService.detectCardType(cardNumber.replace(/\s/g, ""));
  }

  public cardCheck(control: FormControl): ValidationErrors | null
  {
    let fx = num => Number(control.value);
    let intArr = Array.from(String(control.value), fx);
    let sum = 0;
    intArr.forEach(a =>
    {
      sum += a;
    });
    if (sum < 13)
    {
      return { invalidCardNumber: true };
    }
    else
    {
      return null;
    }
  }

  public getCardInfo(): CreditCardInfo
  {
    let result: CreditCardInfo = null;
    if (this.form.dirty)
    {
      const { Address, ...values } = this.form.value; // dont need the extra Address field in form.value. easy way to omit a field.
      result = {
        ...values,
        ...this.form.value.Address,
        Type: this.cardType
      };
    }

    return result;
  }
}
